/** @hidden */
export var __IGLTFExporterExtensionV2 = 0; // I am here to allow dts to be created
//# sourceMappingURL=glTFExporterExtension.js.map